let title = "Ignite by UpContent";

export default {
    title,
    hideShare: true,
    hideSubscription: true,
}
